import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PipesModule } from 'ag-common-svc/shared/pipes/pipes.module';
import { DxDataGridModule } from 'devextreme-angular';
import { SharedModule } from 'ag-common-svc/shared/shared.module';
import { SubversionsGridComponent } from './subversions-grid.component';
import { AgentNameByDbIdePipe } from 'ag-common-svc/shared/pipes/agent.pipe';

@NgModule({
  declarations: [SubversionsGridComponent],
  imports: [CommonModule, PipesModule, DxDataGridModule, SharedModule],
  exports: [SubversionsGridComponent],
  providers: [AgentNameByDbIdePipe],
})
export class SubversionsGridModule {}
